/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Servicenowsysid3Inputs */

const en__field_servicenowsysid3 = /** @type {(inputs: _Field_Servicenowsysid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow ID`)
};

/**
* | output |
* | --- |
* | "ServiceNow ID" |
*
* @param {_Field_Servicenowsysid3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_servicenowsysid3 = /** @type {((inputs?: _Field_Servicenowsysid3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Servicenowsysid3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_servicenowsysid3(inputs)
});
export { _field_servicenowsysid3 as "_field_serviceNowSysId" }